export const DATE_INPUT_FORMAT_DAY_OF_WEEK = 'iii, MMM do, yyyy';
export const DATE_FORMAT_DAY_OF_WEEK = 'ddd, MMM Do, YYYY';
export const DATE_FORMAT_MONTH_YEAR = 'MMM Do, YYYY';
export const DATE_FORMAT_YEAR_MONTH_DAY = 'YYYY/MM/DD';

export const DATE_FORMAT_DATE_TIME = 'MMM Do, YYYY hh:mm A';
export const INTERNATIONAL_DATE_FORMAT = 'DD/MM/YYYY';
export const INTERNATIONAL_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
